const version = "2.1.0";

export { version };
//# sourceMappingURL=version.mjs.map
